import React, {useEffect, useState} from 'react';
import {View, Text, Platform, ActivityIndicator, Linking} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import AsyncStorage from "@react-native-async-storage/async-storage";
import * as SecureStore from "expo-secure-store";
import Bugsnag from "@bugsnag/expo";
import {CommonActions} from '@react-navigation/native';

import {
    loginUser,
    createApiAuthToken,
    verifyUserIsLoggedIn,
    checkCurrentSessionTokenValid,
    setAuthLoading, clearState
} from "../reducers/cbcAuthorizationSlice";

import {
    checkReminderMessages
} from "../reducers/cbcReminderMessagesSlice";

import {fetchLoggingJson} from "../reducers/cbcLoggingSlice";
import {PivotLogging} from "../reducers/cbcLoggingSlice";
import {fetchAllCurrentActivities} from "../reducers/cbcActivitiesSlice";
import {LinearGradient} from 'expo-linear-gradient';
import styled from 'styled-components/native';
import checkReminderMessagesFunction from "../hooks/checkReminderMessages";

import useLocalNotification from "../hooks/localNotificationHandler";
import useLocalNotificationJSONManager from "../hooks/useLocalNotificationJSONManager";

function LoadScreen(props) {

    const {
        scheduleNotification,
        scheduleRecurringNotification,
        getAllScheduledNotifications,
        cancelNotification
    } = useLocalNotification();
    const {
        notificationGroups,
        createNotificationGroup,
        updateNotificationGroup,
        deleteNotificationGroup,
        loadNotificationGroups,
        saveNotificationGroups,
        createNotificationGroupFromDetails
    } = useLocalNotificationJSONManager();

    const dispatch = useDispatch(); // alias for the useDispatch hook

    // get the state values we want to access from the authorization reducer
    const {
        authLoading,
        userId,
        wpAuthorizationToken,
        apiAuthToken,
    } = useSelector((state) => state.cbcAuthorization);

    const [localUserId, setLocalUserId] = useState(0);
    // When the component initially loads, we want to make sure the user
    // is currently logged into the Cerebrocore Website by using React's useEffect hook.
    useEffect(() => {
        //console.log('main effect running');
        dispatch(PivotLogging({moduleName: 'LoadScreen', consoleLog: 'Loading Screen Loaded'}));

        async function sessionVerification() {
            // screen to navigate to based on what platform is being used
            if ('web' === Platform.OS) {
                // we use dispatch here to call our action creator in the authorization reducer
                dispatch(PivotLogging({moduleName: 'LoadScreen', consoleLog: 'Dispatching Action'}));
                dispatch(PivotLogging({moduleName: 'LoadScreen', consoleLog: `Current State for User Id: ${userId}`}));
                dispatch(verifyUserIsLoggedIn({}));
            } else {
                // since we're on mobile, see if there is a session key stored and,
                // if so, see if it's vaild
                const sessionToken = await SecureStore.getItemAsync('apiAuthToken');
                dispatch(PivotLogging({moduleName: 'LoadScreen', consoleLog: `Session ${sessionToken}`}));
                const jwtAuthToken = await SecureStore.getItemAsync('authToken');
                dispatch(PivotLogging({moduleName: 'LoadScreen', consoleLog: `JWT Token, ${jwtAuthToken}`}));
                const userId = await AsyncStorage.getItem('userId');
                setLocalUserId(userId);
                dispatch(PivotLogging({moduleName: 'LoadScreen', consoleLog: `Current User ${userId}`}));
                if (userId === undefined || userId === '0' || userId === null) {
                    console.log('no userId found');
                    dispatch(PivotLogging({moduleName: 'LoadScreen', consoleLog: 'Go to Login Screen'}));
                    Bugsnag.leaveBreadcrumb('New user, navigating to login screen.');
                    //dispatch(clearState());
                    logUserIn();
                    // props.navigation.dispatch(
                    //     CommonActions.reset({
                    //         index: 0,
                    //         routes: [{name: 'login'}],
                    //     })
                    // );
                    return;
                } else {
                    Bugsnag.setUser(userId);
                    // verify that the session key is valid
                    dispatch(
                        checkCurrentSessionTokenValid({
                            userId,
                            sessionToken,
                            jwtAuthToken,
                        })
                    ).then((e) => {
                        console.log(e);
                    });
                }
            }
        }

        sessionVerification();
    }, []);

    // monitor the userid for when we're on web and navigate to the dashboard
    // if the user is successfully authorized or navigate to the dashboard
    // from the app if the current authorization token is valid
    useEffect(() => {
        if ('web' === Platform.OS && userId > 0) {
            dispatch(PivotLogging({moduleName: 'LoadScreen', consoleLog: `User Id ${userId}`}));
            dispatch(fetchAllCurrentActivities({}))
            props.navigation.navigate('tabnavigator');
        }

        if (Platform.OS !== 'web') {
            switch (authLoading) {
                case 'success':
                    //Server reports that we have a valid session, but do we really have everything we need?
                    if (apiAuthToken.length === 0 || wpAuthorizationToken.length === 0 || (userId === "0" || userId === null || userId === 0)) {
                        console.log(apiAuthToken, wpAuthorizationToken, userId);
                        Bugsnag.notify(`Server authorized user login without valid information in state: apiAuthToken: ${apiAuthToken}; wpAuthorizationToken: ${wpAuthorizationToken};  userId: ${userId}; Attempting to relog user.`)
                        //attempting to log user back in.
                        logUserIn();
                    } else {
                        dispatch(
                            setAuthLoading({
                                loadingState: 'idle',
                                resultMessage: '',
                            })
                        );
                        // dispatch(checkReminderMessages(userId)).then((e) => {
                        //     console.log('checkReminderMessages load screen', e);
                        //     checkReminderMessagesFunction(
                        //         scheduleNotification,
                        //         scheduleRecurringNotification,
                        //         cancelNotification,
                        //         notificationGroups,
                        //         {
                        //             createNotificationGroup,
                        //             updateNotificationGroup,
                        //             deleteNotificationGroup,
                        //             loadNotificationGroups,
                        //             saveNotificationGroups,
                        //             createNotificationGroupFromDetails
                        //         }
                        //     );
                        // });
                        // go straight to the dashboard as this is an already authorized user
                        dispatch(fetchAllCurrentActivities({}))
                        console.log('props?', props);
                        // if (props.route.params?.deepLink) {
                        //     const {path, params} = props.route.params.deepLink;
                        //     let screen;
                        //     // Determine the destination screen based on the path
                        //     switch (path) {
                        //         case 'snooze':
                        //             screen = 'snooze';
                        //             break;
                        //         // Define other cases as necessary
                        //     }
                        //
                        //     if (path) {
                        //         // Navigate to the intended screen with parameters if needed
                        //         props.navigation.navigate(path);
                        //     }
                        // }
                    }
                    return;
                    break;
                case 'failed':
                    dispatch(PivotLogging({moduleName: 'LoadScreen', consoleLog: 'Authorization token invalid.'}));
                    Bugsnag.leaveBreadcrumb('Attempting to sign in user with possible stored credentials.');
                    logUserIn();
                    break;
            }
        }
        dispatch(fetchLoggingJson({}));
    }, [userId, authLoading]);

    // FUNCTIONALITY FOR REFRESHING THE SESSION TOKEN WHEN EXPIRED
    async function logUserIn() {
        const savedUsername = await SecureStore.getItemAsync('username');
        const savedPassword = await SecureStore.getItemAsync('password');
        if(!savedUsername && !savedUsername){
            props.navigation.dispatch(
                CommonActions.reset({
                    index: 0,
                    routes: [{name: 'login'}],
                })
            );
        } else {
            dispatch(loginUser({username: savedUsername, password: savedPassword})).then((e) => {
                if(e.type === "cbcAuthorization/loginUser/rejected"){
                    props.navigation.dispatch(
                        CommonActions.reset({
                            index: 0,
                            routes: [{name: 'login'}],
                        })
                    );
                }
            });
        }
    }

    useEffect(() => {
        async function processLogin() {
            dispatch(PivotLogging({
                moduleName: 'LoadScreen',
                consoleLog: `Authorization Token ${wpAuthorizationToken}`
            }));
            if (wpAuthorizationToken.length > 0) {
                await AsyncStorage.setItem('userId', userId.toString());
                await SecureStore.setItemAsync('authToken', wpAuthorizationToken);
                dispatch(
                    createApiAuthToken({
                        userId: userId,
                        jwtAuthToken: wpAuthorizationToken,
                    })
                ).then((e) => {
                    console.log('createApiAuthToken return' , e);
                })
            }
        }

        processLogin();
    }, [wpAuthorizationToken]);

    useEffect(() => {
        async function processNewApiToken() {
            dispatch(PivotLogging({
                moduleName: 'LoadScreen', consoleLog: `Api 
          // navigate to the workout dashboard
          Token: ${apiAuthToken}`
            }));
            if (apiAuthToken.length > 0) {
                await SecureStore.setItemAsync('apiAuthToken', apiAuthToken);
                dispatch(PivotLogging({
                    moduleName: 'LoadScreen',
                    consoleLog: 'Successfully refreshed tokens, navigating to dashboard'
                }));
                dispatch(checkReminderMessages(userId)).then((e) => {
                    console.log('checkReminderMessages load screen', e);
                    checkReminderMessagesFunction(
                        scheduleNotification,
                        scheduleRecurringNotification,
                        cancelNotification,
                        notificationGroups,
                        {
                            createNotificationGroup,
                            updateNotificationGroup,
                            deleteNotificationGroup,
                            loadNotificationGroups,
                            saveNotificationGroups,
                            createNotificationGroupFromDetails
                        }
                    );
                });
                dispatch(fetchAllCurrentActivities({}))
                console.log()
                if (!props.route.params?.deepLink) {
                    props.navigation.dispatch(
                        CommonActions.reset({
                            index: 0,
                            routes: [{name: 'tabnavigator'}],
                        })
                    );
                } else {
                    // alert('deepLink found');
                    // const { path, params } = props.route.params.deepLink;
                    // props.navigation.navigate(path);
                    // return;
                }
                return;
            }
        }

        processNewApiToken();
    }, [apiAuthToken]);

    return (
        <LoadingSplashParent>
            <LinearGradient
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    height: '100%',
                }}
                colors={['rgb(65, 103, 176) ', 'rgb(192, 77, 151)']}
            />
            <SplashImage
                source={{
                    uri: `https://cerebrocoreusa.com/wp-content/plugins/advanced-healthcare-solutions/media/white-brain-logo.png`,
                }}
                resizeMode='contain'
            />
            <ActivityIndicator color="white" size="large"/>
        </LoadingSplashParent>
    );

}

export const LoadingSplashParent = styled.View`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
`;

export const SplashImage = styled.Image`
  width: 250px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default LoadScreen;
